import type { RouteObject } from 'react-router'

const inventoryManagerPage = {
  Component: () =>
    import('@/features/inventory/admin/InventoryManager/InventoryManagerContainer').then(
      (r) => r.default,
    ),
}

/**
 * Creates the service manager page, for admin to mount under its service
 * manager path.
 */
export function createAdminRoutes(): RouteObject[] {
  return [
    { index: true, lazy: inventoryManagerPage },
    { path: '*', lazy: inventoryManagerPage },
  ]
}
